import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Width for inline mm dimension inputs so digits are not clipped */
export function getDimensionInputWidth(value, scale = 1) {
  const digits = String(value ?? '').length || 1;
  return `${Math.max(digits * 12 * scale + 14 * scale, 46 * scale)}px`;
}

/** Total foreignObject width for a value + "mm" suffix */
export function getDimensionLabelBoxWidth(value, scale = 1) {
  const inputWidth = parseFloat(getDimensionInputWidth(value, scale)) || 46 * scale;
  return Math.ceil(inputWidth + 28 * scale);
}
